import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel, Box, Typography } from '@mui/material';

const InspeccionForm = ({ cameraStream, formData, setFormData }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const companias = [
    'Libra', 'Orbis', 'Rio Uruguay Seguros', 'Sancor', 'Allianz',
    'BBVA', 'Mercantil Andina', 'Federacion Patronal', 'HDI', 'Otro'
  ];

  const validateForm = () => {
    const newErrors = {};

    if (!formData.tipoVehiculo) {
      newErrors.tipoVehiculo = 'Seleccione un tipo de vehículo';
    }

    if (!formData.sinPatente && (!formData.patente || formData.patente.trim() === '')) {
      newErrors.patente = 'Ingrese una patente válida';
    }

    if (!formData.telefono || formData.telefono.trim() === '') {
      newErrors.telefono = 'Ingrese un teléfono';
    } else if (!/^\d+$/.test(formData.telefono.replace(/\D/g, ''))) {
        newErrors.telefono = 'Teléfono inválido';
    }

    if (formData.companiaIndex === undefined || formData.companiaIndex === null) {
      newErrors.companiaIndex = 'Seleccione una compañía aseguradora';
    }

    return newErrors;
  };

  useEffect(() => {
    const validationErrors = validateForm();
    setErrors(validationErrors);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      navigate('/carga-fotos');
    }
  };

  return (
    <Box sx={{ p: 4, bgcolor: 'white', color: 'black' }}>
      <Typography variant="h4" sx={{ color: 'black' }}>Inspección de Vehículos</Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth sx={{ mt: 2 }} error={!!errors.tipoVehiculo}>
          <InputLabel sx={{ color: 'black', '&.Mui-focused': { color: 'black' } }}>Tipo de Vehículo</InputLabel>
          <Select
            name="tipoVehiculo"
            value={formData.tipoVehiculo || ''}
            onChange={handleChange}
            sx={{
              bgcolor: 'white',
              color: 'black',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'black' }, 
            }}
          >
            <MenuItem value="">Seleccione</MenuItem>
            <MenuItem value="Auto">Auto</MenuItem>
            <MenuItem value="Moto">Moto</MenuItem>
          </Select>
          {errors.tipoVehiculo && <Typography color="error">{errors.tipoVehiculo}</Typography>}
        </FormControl>

        {!formData.sinPatente && (
          <TextField
            fullWidth
            label="Patente"
            name="patente"
            value={formData.patente || ''}
            onChange={handleChange}
            sx={{
              mt: 2,
              bgcolor: 'white',
              '& .MuiOutlinedInput-root': {
                '& fieldset': { borderColor: 'black' },
                '&:hover fieldset': { borderColor: 'black' },
                '&.Mui-focused fieldset': { borderColor: 'black' }, 
              },
              '& .MuiInputLabel-root': { color: 'black' },
              '& .MuiInputLabel-root.Mui-focused': { color: 'black' }, // Etiqueta roja al enfocar
            }}
            error={!!errors.patente}
            helperText={errors.patente}
          />
        )}
        <FormControlLabel
          control={<Switch name="sinPatente" checked={formData.sinPatente} onChange={handleChange} color="error" />}
          label="No tiene patente"
          sx={{ color: 'black', mt: 1 }}
        />

        <TextField
          fullWidth
          label="Teléfono"
          name="telefono"
          value={formData.telefono || ''}
          onChange={handleChange}
          type="tel"
          sx={{
            mt: 2,
            bgcolor: 'white',
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: 'black' },
              '&:hover fieldset': { borderColor: 'black' },
              '&.Mui-focused fieldset': { borderColor: 'black' }, 
            },
            '& .MuiInputLabel-root': { color: 'black' },
            '& .MuiInputLabel-root.Mui-focused': { color: 'black' }, // Etiqueta roja al enfocar
          }}
          error={!!errors.telefono}
          helperText={errors.telefono}
          inputProps={{ maxLength: 16 }}
        />

        <FormControl fullWidth sx={{ mt: 2 }} error={!!errors.companiaIndex}>
          <InputLabel sx={{ color: 'black', '&.Mui-focused': { color: 'black' } }}>Compañía Aseguradora</InputLabel>
          <Select
            name="companiaIndex"
            value={formData.companiaIndex ?? ''}
            onChange={handleChange}
            sx={{
              bgcolor: 'white',
              color: 'black',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'black' }, 
            }}
          >
            <MenuItem value="">Seleccione</MenuItem>
            {companias.map((comp, idx) => (
              <MenuItem key={idx} value={idx}>{comp}</MenuItem>
            ))}
          </Select>
          {errors.companiaIndex && <Typography color="error">{errors.companiaIndex}</Typography>}
        </FormControl>

        {formData.tipoVehiculo === 'Auto' && (
          <>
            <FormControlLabel
              control={<Switch name="poseeGNC" checked={formData.poseeGNC} onChange={handleChange} color="error" />}
              label="Posee GNC"
              sx={{ color: 'black', mt: 1 }}
            />
            <FormControlLabel
              control={<Switch name="airbagExplotado" checked={formData.airbagExplotado} onChange={handleChange} color="error" />}
              label="Airbag Explotado"
              sx={{ color: 'black', mt: 1 }}
            />
          </>
        )}

        <Button
          type="submit"
          variant="contained"
          sx={{ mt: 3, bgcolor: 'black', color: 'white', '&:hover': { bgcolor: '#333' } }}
          disabled={Object.keys(errors).length > 0}
        >
          Avanzar a Cargar Fotos
        </Button>
      </form>
    </Box>
  );
};

export default InspeccionForm;